module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-54-min.c3be3463.jpg";